a<!--
 * @Date: 2022-09-26 10:50:19
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-09-26 10:52:51
 * @description: description
-->
<template>
  <div :class="$style.aboutusBanner">
    <div :class="$style.bannerBg">
      <div :class="$style.bannerBgImg" />
      <div :class="$style.bannerTitleBox">
        <div :class="$style.bannerTitle">{{ info.title }}</div>
        <div :class="$style.bannerTitleEn">{{ info.titleEn }}</div>
        <!-- <div :class="$style.bannerbtn">进一步了解</div> -->
      </div>
      <!-- <img :class="$style.bannerBgImg" :src="info.cover" alt="这是背景图" /> -->
    </div>
    <div :class="$style.bannerContentBox">
      <p
        :class="$style.contentItem"
        :key="index"
        v-for="(item, index) in info.content"
      >
        {{ item }}
      </p>
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-banner',
  props: {
    info: Object
  }
}
</script>

<style lang="scss" module>
.aboutusBanner {
  position: relative;
  background-image: url("../../../assets/img/aboutus/pc/banner/aboutus-bg.png");
  background-size: 100% 420px;
  background-repeat: no-repeat;

  .bannerBg {
    position: relative;
    z-index: 9;
    height: 420px;
    width: 1200px;
    margin: 0 auto;
  }

  .bannerBgImg {
    position: absolute; top: 74px; right: 60px;
    width: 580px; height: 294px;
    background-image: url("../../../assets/img/aboutus/pc/banner/aboutus-banner.png");
    background-size: 580px 294px;
    background-repeat: no-repeat;
  }

  .bannerTitleBox {
    width: 1200px;
    padding-top: 122px;
    margin: 0 auto;
  }

  .bannerTitle {
    height: 80px;
    line-height: 80px;
    font-size: 42px;
    font-weight: 500;
    color: #333333;
    letter-spacing: 2px;
  }

  .bannerTitleEn {
    width: 123px;
    height: 33px;
    margin-bottom: 54px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    letter-spacing: 2px;
  }

  .bannerbtn {
    width: 260px;
    height: 44px;
    border-radius: 25px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(315deg, #ffd492 0%, #fa8919 100%);
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      background: linear-gradient(315deg, #ffba4e 0%, #ff7f00 100%);
    }
  }

  .bannerContentBox {
    box-sizing: border-box;
    position: relative;
    z-index: 99;
    width: 1200px;
    // height: 320px;
    padding: 40px 60px;
    margin: -80px auto 0;
    background: linear-gradient(145deg, #fff5e7 0%, #ffffff 50%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 16px;
  }

  .contentItem {
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
    color: #404040;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
